<template>
  <div class="flex items-center justify-between w-full">
    <h2>
      {{ $e("Partagez votre flux vidéo") }} :
    </h2>

    <div class="flex items-center">

      <div class="flex">
        <button @click="mode = 'qrcode'" :class="{ 'bg-g3': mode != 'qrcode' }" class="btn w-full rounded-none">{{
          $e("QRCode")
          }}
        </button>
        <button @click="mode = 'email'" :class="{ 'bg-g3': mode != 'email' }" class="btn w-full rounded-none">{{
          $e("Email") }}
        </button>
      </div>

      <button class="btn flex items-center bg-g2 mr-4 ml-8" @click="$emit('close')" :title="$e('Retour')">
        X
      </button>
    </div>
  </div>


  <div class="flex overflow-x-auto max-h-dvh pb-4 w-full pr-1">
    <div class="flex flex-col w-full">

      <div
        class="flex items-center relative text-g3 hover:text-white cursor-pointer w-full pt-2 mb-4 pb-4 border-b border-g3"
        @click="copy(qrCode_url)">
        <input type="text" :value="qrCode_url" readonly class="w-full pr-[8px] !cursor-pointer !text-white">
        <button class="absolute right-[5px]">
          <svg class="fill-current w-[20px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 854.5 854.6">
            <path
              d="M780.5,726.7h-3.9V201.9c0-68.4-55.6-124-123.9-124H127.9v-3.9C127.9,33.2,161.1,0,201.9,0h578.6c40.8,0,74,33.2,74,74v578.7c-.1,40.8-33.2,74-74,74Z" />
            <path
              d="M726.6,780.6V201.9c0-40.8-33.2-74-73.9-74H74C33.2,127.9,0,161.1,0,201.9v578.7c0,40.8,33.2,74,74,74h578.6c40.8,0,74-33.2,74-74ZM333.2,655.5v-134.2h-134.2v-60h134.2v-134.3h60v134.3h134.3v60h-134.3v134.2h-60Z" />
          </svg>
        </button>
      </div>

      <div v-show="mode == 'qrcode'">
        <div id="qrcode" class=""></div>
      </div>

      <div v-show="mode == 'email'">

        <SendEmailList template="QrCode" :subject="$e('Flux vidéo FlyingHub')" :url="qrCode_url" @close="$emit('close')"/>

      </div>
    </div>
  </div>


</template>

<script>
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import User from '@/utils/User';
import SendEmailList from "@/partials/SendEmailList.vue";

export default {
  name: "Pilot_QrCode",
  components: {
    SendEmailList
  },
  setup() {
    return {
      url: ref(''),
      mode: ref('qrcode'),
    };
  },

  props: {
    qrCode_url: String,
  },

  async mounted() {
    let size = 150;

    new QRCode("qrcode", {
      text: this.qrCode_url,
      width: size,
      height: size,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.L
    });

    await $root.user.updateInfo();

    this.sites = await $root.user.getSitesUser([5], 'SITES.all_allowed');

    this.sites.forEach((site) => {
      let mailing_list = site?.sit_option?.mailing_list ?? [];

      mailing_list.forEach((mail) => {
        if (!this.mailing_lists.includes(mail)) {
          this.mailing_lists.push(mail);
        }
      });
    });
  },

  methods: {
    close() {
      this.qrCode_url = false;
    },

    copy() {
      navigator.clipboard.writeText(this.qrCode_url);
      toast.success('Lien copié', this.$root.toastConfig);
    },

    change_mail(index, value) {
      if (index == 'all') {
        if (value) {
          this.mails = {};
          this.mailing_lists.forEach((mail, index) => {
            this.mails[index] = mail;
          });
        }
        else {
          this.mails = {};
        }
      } else {
        if (this.mails.hasOwnProperty(index)) {
          delete this.mails[index];
        } else {
          this.mails[index] = this.mailing_lists[index];
        }
      }
    },

    send_mail() {
      let keys = Object.keys(this.mails);

      if (keys.length == 0) {
        toast.error(
          this.$e('Veuillez sélectionner au moins un mail'),
          this.$root.toastConfig
        );
        return;
      }

      let mails = '';

      keys.forEach((key) => {
        mails += this.mails[key] + ',';
      });

      Mails.sendEmail(
        'QrCode',
        'flying.hub456@gmail.com',
        '',
        mails,
        this.$e('Flux vidéo FlyingHub'),
        {
          lien: this.qrCode_url
        }
      );
    }
  },
};
</script>
